module.exports = "https://web-assets.ifttt.com/packs/media/icons/tornado-8c17da67.png";